export const GET_APPOINTMENT_VISITOR_LIST = 'GET_APPOINTMENT_VISITOR_LIST';
export const GET_APPOINTMENT_VISITOR_REQUEST = "GET_APPOINTMENT_VISITOR_REQUEST";
export const GET_APPOINTMENT_VISITOR_FAILURE = "GET_APPOINTMENT_VISITOR_FAILURE";
export const GET_APPOINTMENT_VISITOR_LIST_SUCCESS = "GET_APPOINTMENT_VISITOR_LIST_SUCCESS"